export const formatCurrency = (
  value?: number,
  currency: string = 'BRL',
  numberOnly: boolean = false,
  decimals: number = 2,
): string => {
  if (value) {
    const v = (value / 100).toLocaleString('pt-BR', {
      style: 'currency',
      currency,
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
      currencyDisplay: numberOnly ? 'code' : undefined,
    });
    return numberOnly ? v.replace(/[a-z]{3}/i, '').trim() : v;
  }

  return 'R$ 0,00';
};

export const formatNumber = (value?: number, forceDecimals: boolean = false, round: boolean = false): string => {
  if (value) {
    const v = round ? Math.round(value) : value;
    return v.toLocaleString('pt-BR', {
      style: 'decimal',
      minimumFractionDigits: forceDecimals ? 2 : undefined,
      maximumFractionDigits: forceDecimals ? 2 : undefined,
    });
  }

  return '0';
};

export const formatPercentage = (value: number | undefined, digits?: number): string => {
  if (value) {
    return value.toLocaleString('pt-BR', {
      style: 'percent',
      minimumFractionDigits: digits ?? undefined,
      maximumFractionDigits: digits ?? undefined,
    });
  }

  return '0%';
};
